(function(){
    'use strict';

    /**
     * ===================================================
     * Form helpers
     * Add the following code if you want the name of the file appear on select
     * ===================================================
     */
    $('.sq-form-upload input').on('change', function() {

        var fileName = $(this).val().split('\\').pop();

        // disable replacement of file upload label text with uploaded file name
        // $(this).closest('.sq-form-question').find('.sq-form-question-title').addClass('selected').html(fileName);
    });


    /**
     * ===================================================
     * Form helpers
     * https://getbootstrap.com/docs/4.3/components/forms/#checkboxes
     * ===================================================
     */
    $('.sq-form-question-answer').each(function() {

        var $checkOrRadio = $(this);

        if( $($checkOrRadio).find(':radio').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-radio"></div>');
        }

        if( $($checkOrRadio).find(':checkbox').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-checkbox"></div>');
        }
    });

    //text area characters remaining code
    let $textAreas = $('textarea');

    for (var i = 0; i < $textAreas.length; i++){
        var area = $textAreas[i];
        var areaId = area.getAttribute('id');
        var textMax = area.getAttribute('maxlength');
        
        if (textMax != null) {

            $(`<div class='${areaId}_feedback'></div>`).insertAfter(area)

            $(`.${areaId}_feedback`).html(`${textMax} / ${textMax} characters remaining`);

            const ID = areaId;
            const max = textMax;
            $(`#${areaId}`).on('keyup', function (t) {
                
                var textLength = $(`#${ID}`).val().length;
                var textRemaining = max - textLength;

                $(`.${ID}_feedback`).html(`${textRemaining} / ${max} characters remaining`);
            });
        }
    }

    /**
     * ===================================================
     * Form File Upload Clear Field
     *  add custom class to the clear field to show checkbox
     * ===================================================
     */
    $("input[type='checkbox']").each(function() {
        var currentInput = $(this);
        var attributeName = currentInput.attr('name');
        if (attributeName.includes('_clear[]')) {
            currentInput.addClass('file-clear');
        }
    });

}());
